import Activate2FA from './Activate2FA'

export default Activate2FA